import { GameTileProps } from '../../components/modular-grid/types';
import { ControllersDataItem } from '../../logic/main/types';

export const extractGamesFromController = (
  controllersData?: Pick<ControllersDataItem, 'components'>
) => {
  if (!controllersData) {
    return [];
  }
  const { components = [] } = controllersData;
  return components.reduce((allGames: GameTileProps[], component) => {
    const games = component?.[1]?.properties?.games || [];
    return allGames.concat(games);
  }, []);
};
